import {
  FilazeroPaymentMethod,
  OrderPayment,
  OrderPaymentResource,
  OrderPaymentResourcePage,
  PageOf,
  OrderPaymentPageQuery
} from '@/models'

import axios, { withToken } from './axios'

/**
 * Converts OrderPaymentResource to OrderPayment.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOrderPaymentResource (resource: OrderPaymentResource): OrderPayment {
  return {
    id: resource.id,
    status: resource.status,
    createAt: new Date(resource.createAt),
    lastUpdate: new Date(resource.lastUpdate),
    amount: resource.amount,
    ownerId: +resource.ownerId
  }
}

/**
 * Converts OrderPaymentResourcePage to PageOf<OrderPayment>.
 *
 * @param resource Reponse data to be converted.
 */
export function parseOrderPaymentResourcePage (page: OrderPaymentResourcePage): PageOf<OrderPayment> {
  return {
    elements: page.orderPayments.map(parseOrderPaymentResource),
    total: page.count
  }
}

export async function fetchOrderPaymentPage (
  token: string,
  providerId: number,
  businessUnitId: number,
  query: OrderPaymentPageQuery
): Promise<PageOf<OrderPayment>> {
  const response = await axios.get<OrderPaymentResourcePage>(
    `/v2/order-payment/providers/${providerId}/orders/locations/${businessUnitId}`,
    {
      params: query,
      ...withToken(token)
    }
  )

  return parseOrderPaymentResourcePage(response.data)
}

export async function fetchOrderPayment (
  providerId: number,
  ownerId: number
): Promise<OrderPayment> {
  const response = await axios.get<OrderPaymentResource>(
    `/v2/order-payment/providers/${providerId}/orders/${ownerId}?applicationType=1`
  )

  return parseOrderPaymentResource(response.data)
}

export async function latePayment (
  token: string,
  providerId: number,
  orderId: number,
  paymentMethod: FilazeroPaymentMethod
): Promise<void> {
  const body = {
    paymentMethod,
    gateway: 0,
    data: null
  }

  await axios.post(
    `/v2/order-payment/providers/${providerId}/orders/${orderId}/payment-operator`,
    body,
    withToken(token)
  )
}

export default {
  fetchOrderPaymentPage,
  fetchOrderPayment,
  latePayment
}
